import { get, patch, post } from '@/api/axios';
import { AnnouncementEndpoints } from '@/api/endpoints/AnnouncementEndpoints';
import { type AnnouncementRecipientDto } from '@/app/models/AnnouncementRecipientDto';
import { type ListData } from '@/app/models/ListData';

const BELL_ANNOUNCEMENT_COUNT = 10;

export const listPendingAnnouncements = () => get<AnnouncementRecipientDto[]>(AnnouncementEndpoints.myPending);

export const listLatestReceivedAnnouncements = () =>
  post<ListData<AnnouncementRecipientDto>>(AnnouncementEndpoints.myList, {
    search: '',
    sort: 'published_date',
    direction: 'DESC',
    per_page: BELL_ANNOUNCEMENT_COUNT,
  });

export const updateAnnouncementSeen = (id: string) => patch<AnnouncementRecipientDto>(AnnouncementEndpoints.seen(id));

export const updateAnnouncementAcknowledged = (id: string) =>
  patch<AnnouncementRecipientDto>(AnnouncementEndpoints.acknowledge(id));

export const updateAnnouncementDismissed = (id: string) =>
  patch<AnnouncementRecipientDto>(AnnouncementEndpoints.dismiss(id));
